module.exports = __webpack_public_path__ + "static/media/mat-transition-right.c4b9cb7b.png";